import { MockedRequest, RequestHandler, rest, restContext } from 'msw';
import { Account, MyI9ResponseFromJSON } from 'eve-account-client';
import {
  employer,
  agency,
  corporate,
  employerWithWebService,
  agencyWithWebService,
  corporateWithWebService,
  employerWithMyI9EnabledSigned,
} from '../fixtures/accountTypes';
import states from '../fixtures/states';

const accounts: Array<Account> = [
  employer,
  employerWithWebService,
  agency,
  agencyWithWebService,
  corporate,
  corporateWithWebService,
  employerWithMyI9EnabledSigned,
];

const evePlusEligibleAccountIds: Array<string | undefined> = ['2'];

const handlers: RequestHandler<MockedRequest, typeof restContext>[] = [
  rest.get('/api/account/accounts/:id', (req, res, ctx) => {
    const account = accounts.find((a) => a.id === req.params.id);

    if (account) {
      return res(ctx.json(account));
    }

    return res(ctx.status(404), ctx.json({ message: 'Account Not Found' }));
  }),

  rest.get('/api/account/reference-data/states', (req, res, ctx) => {
    return res(ctx.json(states));
  }),

  rest.put('/api/account/accounts/:id/myi9', (req, res, ctx) => {
    const myI9Response = MyI9ResponseFromJSON({
      enabled: true,
      signedUsername: 'ABCD1234',
      signedDate: '2023-07-21T17:32:28Z',
    });
    return res(ctx.json(myI9Response));
  }),

  rest.get('/api/account/accounts/:id/myi9/eligibility', (req, res, ctx) => {
    const account = accounts.find((a) => a.id === req.params.id);

    if (account) {
      return res(ctx.json({ isEligible: evePlusEligibleAccountIds.includes(account.id) }));
    }

    return res(ctx.status(404), ctx.json({ message: 'Account Not Found' }));
  }),
];

export default handlers;
